// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-inputs .form-control {
  height: 40px;
}

.form-inputs .form-control:focus {
  box-shadow: none;
  border: 1px solid #000;
}

.form-control {
  min-width: 350px;
}

.search-icon {
  margin-right: 40px;
  background-color: #333742;
  padding-left: 13px;
  padding-right: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgb(210, 207, 207);
  border-radius: 16%;
  cursor: pointer;
}
.search-icon:hover {
  color: white;
  background-color: #3B71CA;
  transition: all 0.4s ease-in-out;
}

.btn-submit {
  background-color: #0060d6;
  color: white;
  transition: background 0.3s ease-in-out;
}

.btn-submit:hover {
  background-color: #1a1a86;
}`, "",{"version":3,"sources":["webpack://./src/app/features/digital-identity/identity-provisioning/assign-digital-id/assign-digital-id.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEA;EACI,gBAAA;EACA,sBAAA;AACJ;;AACA;EACI,gBAAA;AAEJ;;AAGA;EAEI,kBAAA;EACA,yBAAA;EAEA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAFJ;AAII;EACI,YAAA;EACA,yBAAA;EACA,gCAAA;AAFR;;AAMA;EACE,yBAAA;EACA,YAAA;EACA,uCAAA;AAHF;;AAMA;EACE,yBAAA;AAHF","sourcesContent":[".form-inputs .form-control{\r\n    height:40px; \r\n}\r\n\r\n.form-inputs .form-control:focus{\r\n    box-shadow:none;\r\n    border:1px solid #000;\r\n}\r\n.form-control {\r\n    min-width: 350px;\r\n    // margin-right: 1px;\r\n}\r\n\r\n\r\n.search-icon{\r\n    //margin-top:1px;\r\n    margin-right: 40px;\r\n    background-color: #333742; \r\n    //padding: 9px; \r\n    padding-left: 13px;\r\n    padding-right: 13px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    color: rgb(210, 207, 207);\r\n    border-radius:16%;\r\n    cursor: pointer;\r\n\r\n    &:hover{\r\n        color: white; \r\n        background-color: #3B71CA;\r\n        transition: all 0.4s ease-in-out;\r\n    }\r\n}\r\n\r\n.btn-submit {\r\n  background-color: #0060d6;\r\n  color: #ffff;\r\n  transition: background 0.3s ease-in-out;\r\n}\r\n\r\n.btn-submit:hover {\r\n  background-color: #1a1a86;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
